import { useState,useEffect, useRef } from "react";
import PhotoPlaceholder from '../PagesClaude/placeholder';


const About = ({ pages, blog, openLightbox }) => {
	
	
	useEffect(() => {
		window.scrollTo(0,0);
	}, []);
	
	const [open, setOpen] = useState(null);
	const itemRefs = useRef({});
	const toggle = (n) => {
		setOpen((cur) => (cur === n ? null : n));
	};
	
	useEffect(() => {
		if (!open) return;
		const el = itemRefs.current[open];
		if (!el) return;
		const t = setTimeout(() => {
			const nav = document.querySelector(".wi-nav");
			const navH = nav ? nav.getBoundingClientRect().height : 0;
			const top = el.getBoundingClientRect().top + window.scrollY - navH - 16;
			window.scrollTo({ top, behavior: "smooth" });
		}, 380);
		return () => clearTimeout(t);
	},   [open]);
	


	return (
		
		<main className="wi-about">

			<header className="wi-about-head">
				<div className="wi-mono wi-eyebrow" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "studio-left").dataJson.country}}></div>
				<h1 className="wi-about-title"  data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "studio-left").subtitle}}></h1>
			</header>
			
			<section className="wi-about-body">
				<div className="wi-about-col" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "studio-left").description}}></div>
				<div className="wi-about-col" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "studio-right").description}}></div>
			</section>
			
			{blog.length > 0 && 
				<section className="wi-about-cycles">
					<div className="wi-mono wi-eyebrow" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "studio-right").subtitle}}></div>
					<ul className="wi-cycle-list">
						{blog.map((c,cIdx) => {
							const isOpen = open === c.id;
							return (

								<li
									key={c.id}
									ref={(el) => (itemRefs.current[c.id] = el)}
									className={`wi-cycle-item ${isOpen ? "is-open" : ""}`}
								>
									<button
										className="wi-cycle-row wi-cycle-toggle"
										onClick={() => toggle(c.id)}
										aria-expanded={isOpen}
										aria-controls={`cycle-${c.id}-panel`}
										>
											<span className="wi-mono wi-cycle-n">{c.jsonData?.location}</span>
											<span className="wi-cycle-y">{c.date_content.replaceAll('-','/')}</span>
											<span className="wi-italic wi-cycle-p">{c.title}</span>
											<span className="wi-cycle-meta-r">
												<span className="wi-mono wi-cycle-c">
													{(c.media.length > 0) 
														? `${parseInt(c.media.length)} image${c.media.length !== 1 ? "s" : ""}`
														: ''
													}
												</span>
												<span className="wi-mono wi-cycle-c" hidden>
													{Math.max(1, parseInt(c.description.length/1000))} min read
												</span>
												<span className="wi-cycle-chev" aria-hidden>
													{isOpen ? "−" : "+"}
												</span>
											</span>
									</button>

									<div
										id={`cycle-${c.id}-panel`}
										className="wi-cycle-panel"
										role="region"
										aria-hidden={!isOpen}
									>
										<div className="wi-cycle-panel-inner">
											<div className="wi-cycle-note">
												<h2 className="wi-about-subtitle">{c.subtitle}</h2>
												<br />

												{c.media.length > 0 &&
													<div className="wi-mosaic">
														<button
															className="wi-print-frame"
															onClick={() => openLightbox(c.media[0].id, c.media)}
														>
															<PhotoPlaceholder
																src={c.media[0].cdnUrl}  
																caption={c.media[0].title}
																ratio={"16/9"}
																index={1 + 30}
																showMeta={false}
																imgStyle={{ filter: 'none', objectFit: 'cover'}}
															/>
															<br />
															<span
																className="wi-btn-ghost"
																>
																	<span className="wi-mono">View {c.media.length} image{c.media.length !== 1 ? "s" : ""}</span>
																	<span aria-hidden>↗</span>
															</span>
														</button>
													</div>
												}	
												
												<p data-insert-htmlx dangerouslySetInnerHTML={{__html: c.description}} ></p>
											</div>
											<dl className="wi-cycle-facts">
												<div>
													<dt className="wi-mono">Field</dt>
													<dd>{c.jsonData.field}</dd>
												</div>
												<div>
													<dt className="wi-mono">Client</dt>
													<dd>{c.jsonData.client}</dd>
												</div>
												<div>
													<dt className="wi-mono">Gear</dt>
													<dd>{c.jsonData.user}</dd>
												</div>
											</dl>
										</div>

									</div>

								</li>
							);
						})}
					</ul>
				</section>
			}
			
		</main>
	);
};

export default About;
